export function Header({ title, boldTitle, subheader }: any) {
  return (
    <div className="relative overflow-hidden">
      <div className="absolute inset-y-0 w-full h-full" aria-hidden="true">
        <div className="relative h-full"></div>
      </div>

      <div className="relative pt-6">
        <div className="px-4 mx-auto max-w-7xl sm:px-6">
          <div className="text-center">
            <h1 className="text-4xl font-extrabold tracking-tight text-gray-900 sm:text-5xl md:text-6xl">
              <span className="block">{title}</span>
              <span className="block text-clerk-blue">{boldTitle}</span>
            </h1>
            <p
              className="max-w-md mx-auto mt-3 text-base text-gray-500 sm:text-lg md:mt-5 md:text-xl md:max-w-3xl"
              dangerouslySetInnerHTML={{ __html: subheader }}
            ></p>
          </div>
        </div>
      </div>
    </div>
  );
}
